var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStubSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#a6acb5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22,11.48A2.38,2.38,0,0,1,9.88,8.63l.64-.25a1.38,1.38,0,0,0,.92-1.26A1.3,1.3,0,0,0,10,5.77,1.53,1.53,0,0,0,8.48,7.32H6.32A3.51,3.51,0,0,1,10,3.56,3.37,3.37,0,0,1,13.68,7a3.42,3.42,0,0,1-2.4,3.35c-.67.23-1.15.41-1.15,1.14v.33H8.22Zm-.53,3.17a1.42,1.42,0,0,1,1.47-1.41,1.426,1.426,0,1,1,0,2.85,1.43,1.43,0,0,1-1.47-1.44Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStubSlot);
export default __webpack_public_path__ + "static/media/stub-slot.a602cf65fb81374179e1fc83d17e400e.svg";
export { ForwardRef as ReactComponent };